import { EquipmentMonitoringApi } from '@wiz-api/emergency-management'
import { AreaApi } from '@wiz-api/area-management'
import { Tag3DPositionImgApi } from '@wiz-api/tag-3d-position-management'
import { map, forEach, reduce, find } from 'lodash'
import { createByPicture } from '../common'
import bus from '../../../components/business/EmergencyDisposal/bus'

const equipmentMonitoringApi = new EquipmentMonitoringApi()
const areaApi = new AreaApi()
const tag3DPositionImgApi = new Tag3DPositionImgApi()

/** ************************************************ 监控列表 **************************************** */
let cameraList = []
let imageList = []
let markerList = []
let areaList = []
let cloudRender
// 获取监控列表
const getDataList = async (areaId) => {
  const params = {
    skipCount: 0,
    maxResultCount: 999,
    isPoint: true,
    areaId,
  }
  if (!areaId) {
    params.areaIds = areaList.map((item) => {
      return item.id
    })
  }
  const [err, res] = await equipmentMonitoringApi.pagedListQuery(params)
  if (!err) {
    return res.items
  }
  return []
}
// 获取监控图标列表
const getBasicIconList = async () => {
  const [err, res] = await tag3DPositionImgApi.findPagedTag3DPositionImgsList({
    tagTypeCode: 'IOTDeviceCamera',
    skipCount: 0,
    maxResultCount: 999,
  })
  if (!err) {
    imageList = res.items
  }
}
// 获取风险区域列表
const getAreaList = async (sourceId) => {
  const [err, res] = await areaApi.getList({
    modelId: sourceId,
    skipCount: 0,
    maxResultCount: 1000,
  })
  if (!err && res) {
    areaList = res.items
  }
}
// 创建监控标签
const create = async (player, propCloudRender, sourceId, areaId) => {
  await getAreaList(sourceId)
  await getBasicIconList()
  cameraList = await getDataList(areaId)
  const options = []
  for (let i = 0; i < cameraList.length; i += 1) {
    const item = cameraList[i]
    options.push({
      id: item.id,
      pos: item.threeDPosition ? JSON.parse(item.threeDPosition) : [0, 0, 0], // 定位点，世界坐标，三维向量，默认值为[0, 0, 0]
      visible: true, // 显示隐藏状态，boolean类型，默认值为true
      backgroundUrl:
        find(imageList, { id: item.tagFileImgId })?.threeDServerFilePath ||
        'data://../apps/CDU/icon/new-camara-blue.png',
      imgSize: [54, 54], // 图片显示大小，二维向量，-1表示使用图片原始大小，如[32, -1]为宽度设置为32（拉伸或压缩），高度为图片高度，默认值为[-1, -1]，均使用图片尺寸
      nodeOffset: [0, 0], // 相对定位点的偏移量，二维向量，默认值为[0, 0]，标记左上角与定位点重合
      markPosType: 4,
    })
  }
  cloudRender = propCloudRender
  const res = await createByPicture(player, cloudRender, options)
  markerList = [...res.data]
  cloudRender.Dispatch.on('Marker', (data) => {
    const currentMarker = _.find(markerList, ['pointer', data.markerId])
    if (currentMarker) {
      const currentData = _.find(cameraList, ['id', currentMarker.id])
      bus.$emit('translate', { row: currentData, type: 'camera' })
    }
  })
}
const update = async (player, propCloudRender, sourceId, areaId) => {
  if (!player.Native) {
    return
  }
  // 获取新的摄像头区域数据
  const newRouteList = await getDataList(areaId)
  const newRouteIds = map(newRouteList, (i) => {
    return i.id
  })
  const iconInstanceToUpdate = reduce(
    markerList,
    (acc, item) => {
      const action = newRouteIds.includes(item.id) ? 'show' : 'hide'
      item.visible = action === 'show'
      acc[action].push(item)
      return acc
    },
    { hide: [], show: [] }
  )
  await cloudRender.Marker.updateByPicture(
    map([...iconInstanceToUpdate.show, ...iconInstanceToUpdate.hide], (i) => {
      return {
        id: i.pointer,
        visible: i.visible,
      }
    })
  )
}
const destroy = async (player) => {
  await cloudRender.Marker.destroyMarker(_.map(markerList, 'pointer'))
}
export default { create, destroy, update }
